import React from 'react';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative flex flex-col pt-24 pb-0 overflow-hidden" data-id="element-135">
      {/* Decorative elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-136">
        <div className="absolute -top-[30%] -right-[10%] w-[70%] h-[70%] rounded-full bg-gradient-to-br from-[#BBDDFF]/20 to-transparent blur-3xl" data-id="element-137"></div>
        <div className="absolute -bottom-[30%] -left-[10%] w-[70%] h-[70%] rounded-full bg-gradient-to-tr from-[#C85A15]/10 to-transparent blur-3xl" data-id="element-138"></div>
      </div>
      <div className="container mx-auto px-6 relative z-10 pb-0 flex-grow flex flex-col justify-center" data-id="element-139">
        <div className="max-w-4xl mx-auto text-center" data-id="element-140">
          <div className="inline-block mb-6 px-4 py-1 rounded-full bg-gradient-to-r from-[#BBDDFF]/20 to-[#C85A15]/20 backdrop-blur-sm border border-white/10" data-id="element-141">
            <span className="text-sm font-medium bg-gradient-to-r from-gray-900 to-gray-700 dark:from-white dark:to-gray-300 bg-clip-text text-transparent" data-id="element-142">
              The future of digital healthcare
            </span>
          </div>
          <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight" data-id="element-143">
            <span className="bg-gradient-to-r from-gray-900 to-gray-700 dark:from-white dark:to-gray-300 bg-clip-text text-transparent" data-id="element-144">
              Lose weight{' '}
            </span>
            <span className="bg-gradient-to-r from-[#BBDDFF] to-[#C85A15] bg-clip-text text-transparent" data-id="element-145">
              the proven way
            </span>
          </h1>
          <p className="text-xl text-gray-600 dark:text-gray-300 mb-10 max-w-2xl mx-auto" data-id="element-146">
            GLP-1 Medications, tracking, and access to a dedicated physician and
            care team to make sure your treatments and weight loss goals are
            aligned.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-147">
            <a href="https://app.joinomu.com/patient/onboarding" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto font-medium py-3 px-8 rounded-full hover:shadow-lg transition-all flex items-center justify-center group" style={{
            backgroundColor: '#EA580C',
            color: '#F7F4F3'
          }} data-id="element-148">
              <span data-id="element-149">Treatments & Pricing</span>
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={18} style={{
              color: '#F7F4F3'
            }} data-id="element-150" />
            </a>
          </div>
        </div>
        <div className="mt-0 relative mb-0" data-id="element-151">
          <div className="w-screen relative left-1/2 right-1/2 -mx-[50vw]" data-id="element-152">
            <img src="https://cdn.magicpatterns.com/uploads/rJtAMe8TT3YCXXnNgerJ77/Frame_1261155279.png" alt="JoinOmu - Two women smiling, representing health and wellness" className="w-full h-auto block" data-id="element-153" />
          </div>
        </div>
      </div>
    </section>;
}